/* eslint-disable */
import React from 'react';
import { Input as SonntagInput } from '@getgrover/ui';

const Input = ({ value, inputProps, ...props }) => (
    <SonntagInput {...props} inputProps={{ value, ...inputProps }} />
);

export default Input;
